import moment from 'moment';

/**
 * Firestore Timestamp를 형식화된 날짜 문자열로 변환합니다.
 *
 * @param {firebase.firestore.Timestamp} timestamp - 변환할 Firestore Timestamp.
 * @returns {string} 'YYYY/MM/DD HH:mm:ss' 형식의 날짜 문자열.
 */
export function formatTimestamp(timestamp, pattern = 'YYYY/MM/DD HH:mm:ss') {
	if (!timestamp) return '';

	// 이미 Date 객체인 경우 그대로 사용
	let date = timestamp instanceof Date ? timestamp : new Date(timestamp);

	// toDate가 있는지 확인하고, 있다면 호출
	if (typeof timestamp.toDate === 'function') {
		date = timestamp.toDate();
	}

	return moment(date).format(pattern);
}

/**
 * 메시지 문자열의 개행 문자를 HTML 줄 바꿈 태그로 변환합니다.
 *
 * @param {string} message - 형식화할 메시지 문자열.
 * @returns {string} 개행 문자가 '<br>'로 대체된 형식화된 메시지 문자열.
 */
export function formatMessage(message) {
	if (!message) return '';
	return message.replace(/\n/g, '<br>');
}
/**
 * 텍스트 문자열이 지정된 길이보다 길 경우,
 * 해당 길이만큼 자르고 말줄임표('...')를 추가합니다.
 * 개행 처리가 true일 경우, 개행 문자를 '<br>'로 변환합니다.
 *
 * @param {string} text - 자를 텍스트 문자열.
 * @param {number} maxLength - 텍스트의 최대 길이.
 * @param {boolean} newlineHandling - 개행 처리를 할지 여부.
 * @returns {string} 자른 후 말줄임표를 추가하고, 개행 처리가 된 문자열.
 */
export function truncateText(text, { maxLength = 10, newlineHandling = false } = {}) {
	let truncatedText = text;
	if (text.length > maxLength) {
		truncatedText = text.substring(0, maxLength) + '...';
	}
	if (newlineHandling) {
		return formatMessage(truncatedText);
	}
	return truncatedText;
}
